var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.711 10.98v2.342c0 .608.334 1.175.867 1.467l4.167 2.275c.5.275 1.1.275 1.6 0l4.167-2.275c.533-.292.866-.859.866-1.467V10.98l-5.033 2.75c-.5.275-1.1.275-1.6 0zm5.034-8.05L1.72 6.764a.84.84 0 0 0 0 1.466l7.025 3.834c.5.275 1.1.275 1.6 0l6.7-3.659v4.925c0 .459.375.834.833.834a.836.836 0 0 0 .834-.834V7.99a.838.838 0 0 0-.434-.734L10.345 2.93a1.7 1.7 0 0 0-1.6 0z",
    fill: "#3964ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.c4f4bd43dcc3f277c096966a5799ca4e.svg";
export { ForwardRef as ReactComponent };